import { fetchWindsRegionText, parseStationLine } from "../components/windsAloft";

/**
 * ------------------------------------------------------------
 * Load winds aloft for all forecast terminal rows
 * ------------------------------------------------------------
 */
export async function loadWindsForTerminals(windsRegion, windsFcst, prevRows, altitudes) {
  const result = await fetchWindsRegionText(windsRegion, windsFcst);

  if (!result?.rawText) return prevRows;

  return prevRows.map((row) => {
    const parsed = parseStationLine(result.rawText, row.ft, altitudes);
    if (!parsed) return row;

    return {
      ...row,
      ...parsed,
      alt1: altitudes.alt1,
      alt2: altitudes.alt2,
      alt3: altitudes.alt3,
    };
  });
}